export default {
  tasks: null,
  taskTickets: null,
};
